<template>
  <div
    class="overlay"
    :class="[isShow ? showClass : hideClass]"
    id="popup-return"
  >
    <div class="popup" style="width: 450px">
      <div class="popup-body">
        <div class="popup-status">
          <p class="popup-status-text newline">{{ message }}</p>
        </div>
        <div class="frm-btn-row">
          <div class="frm-item grow center">
            <button
              class="frm-btn strong large"
              @click="confirm"
              :disabled="isOkDisabled"
              ref="refYesBtn"
            >
              はい
            </button>
            <button class="frm-btn large" @click="cancel" @blur="onblur">いいえ</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Common from "@/util/common.js";
import { mapMutations } from "vuex";
export default {
  name: "ConfirmDialog",
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
    message: {
      type: String,
      default: Common.getMessage("MTFM5030", []),
    },
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      isOkDisabled: false,
    };
  },
  computed: {},
  methods: {
    ...mapMutations("businessModule", ["handleBodyScrollOnModalStateChange"]),
    // **********************************************
    // * confirmダイアログではいが選択された時の処理
    // **********************************************
    confirm() {
      this.$emit("confirm");
    },
    // **********************************************
    // * confirmダイアログでいいえが選択された時の処理
    // **********************************************
    cancel() {
      this.$emit("cancel");
    },
    onblur(e){
      if(!e) return;
      e.preventDefault();
      this.$refs.refYesBtn.focus();
    },
    initFocus(){
      this.$refs.refYesBtn.focus();
    },
  },
  watch: {
    isShow: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.initFocus();
        });
      }
      this.handleBodyScrollOnModalStateChange(newVal)
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 768px) {
  .popup>.popup-body>.frm-btn-row>.frm-item {
    flex-wrap: wrap;
    gap: 10px;
  }
  .frm-btn+.frm-btn {
    margin-left: 0px;
  }
}
</style>